// @flow
import * as React from 'react';
import classNames from 'classnames';
import _ from 'lodash';

import Scrollable from '../../Scrollable';
import * as css from './SelectOptions.scss';

type Props = {
	className?: string,
	isShown: boolean,
	options: Array<string>,
	onOptionClick: (cityName: string) => void,
	labelPostfix?: string,
};

const SelectOptions = (props: Props) => {
	const { className, options, isShown } = props;

	const onOptionClick = React.useCallback(
		(e: SyntheticEvent<HTMLButtonElement>) => {
			const { city } = e.currentTarget.dataset;

			props.onOptionClick(city);
		},
		[options, props.onOptionClick]
	);

	return (
		<div className={classNames(css.selectOptions, isShown && css.shown, className)}>
			<Scrollable>
				{isShown &&
					_.map(options, (option, index) => {
						return (
							<button
								className={css.option}
								data-city={option}
								onClick={onOptionClick}
								type="button"
								key={`${option}-${index}`}
							>
								<span>
									{option}
									{props.labelPostfix ? props.labelPostfix : ''}
								</span>
							</button>
						);
					})}
			</Scrollable>
		</div>
	);
};

SelectOptions.defaultProps = {
	className: '',
	labelPostfix: '',
};

export default SelectOptions;
